<template>
  <div class="message">
    <textarea class="textarea disp-scroll"
      :value="mainmessage.replace('[memo]', '').replace('[/memo]', '')"
      placeholder="MEMO"
      @input="$emit('input', $event.target.value)"
      :disabled="isConfirm">
    </textarea>
  </div>
</template>

<script>
export default {
  props: {
    mainmessage: {
      type: String,
      required: true
    },
    isConfirm: {
      type: Boolean,
      required: false
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/organisms/chatbot/modals/ModalFusenParts.vue